import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { PaymentPageData } from '../../interfaces/payment-page/payment-page-data';

@Injectable({
  providedIn: 'root'
})
export class TechDataToTableDataMapper {

  authService = inject(AuthService);

  constructor() { }

  public map(paymentData: PaymentPageData): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'MERCHANTID',
        value: this.authService.organisationData?.displayCustomerNumber
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTPAGEID',
        value: paymentData?.projectId  ? paymentData.projectId : '',
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PASSWORD',
        value: paymentData.password,
        valueType: 'PASSWORD'
      },
    ];
  }

}
